import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  PROGRESS_HISTORY_FEATURE_KEY,
  ProgressHistoryState,
  ProgressHistoryPartialState,
  progressHistoryAdapter,
} from './progress-history.reducer';
import { ProgressHistoryReportDto } from '@cradua/data';

// Lookup the 'ProgressHistory' feature state managed by NgRx
export const getProgressHistoryState = createFeatureSelector<
  ProgressHistoryPartialState,
  ProgressHistoryState
>(PROGRESS_HISTORY_FEATURE_KEY);

const { selectAll, selectEntities } = progressHistoryAdapter.getSelectors();

export const getProgressHistoryLoaded = createSelector(
  getProgressHistoryState,
  (state: ProgressHistoryState) => state.loaded
);

export const getProgressHistoryError = createSelector(
  getProgressHistoryState,
  (state: ProgressHistoryState) => state.error
);

export const loadingProgressHistory = createSelector(
  getProgressHistoryState,
  (state: ProgressHistoryState) => state.loaded
);

export const getAllProgressHistory = createSelector(
  getProgressHistoryState,
  (state: ProgressHistoryState) => selectAll(state)
);

export const getProgressHistoryEntities = createSelector(
  getProgressHistoryState,
  (state: ProgressHistoryState) => selectEntities(state)
);

export const getSelectedId = createSelector(
  getProgressHistoryState,
  (state: ProgressHistoryState) => state.selectedProgressHistoryId
);

export const getSelected = createSelector(
  getProgressHistoryEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);

export const getSearchStudentRecord = createSelector(
  getAllProgressHistory,
  getSelectedId,
  (users: ProgressHistoryReportDto[], selectedId) =>
    !selectedId
      ? null
      : users.filter(
          (user) =>
            user.id.toLowerCase().includes(String(selectedId).toLowerCase()) ||
            user.ProjectActivityName.toLowerCase().includes(
              String(selectedId).toLowerCase()
            ) ||
            user.ReportNote.toLowerCase().includes(
              String(selectedId).toLowerCase()
            )
        )
);
